import React, { useState, useEffect } from "react";
import api from "../utils/Api";
import SyncLoader from "react-spinners/SyncLoader";
import def from "../assets/bg-img/default.png"
/* eslint-disable no-unused-vars */



const StudentDetails = () => {
  const [studentDetails, setStudentDetails] = useState([]);
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false); // State to track loading
 

  // Add state for enrollId and branchId
  const [enrollId, setEnrollId] = useState(null);
  const [branchId, setBranchId] = useState(null);

  // Fetch student details from backend
  const fetchStudentDetails = async () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    const enrollId = localStorage.getItem("enrollId");
    const fd = new FormData();
    fd.append("programType", "getStudentDetails");
    fd.append("enrollId", enrollId);
    fd.append("authToken", token);
  
    try {
      const response = await api.post("parentApp/studentCurl2", fd);
      // console.log("Student API Response:", response);
  
      if (response.data?.success && Array.isArray(response.data.data)) {
        const student = response.data.data[0];
  
        // ✅ Save class_id and section_id to localStorage
        if (student?.class_id && student?.section_id) {
          localStorage.setItem("classId", student.class_id);
          localStorage.setItem("sectionId", student.section_id);
        }
  
        setStudentDetails(response.data.data);
      } else {
        console.error("Invalid API response structure:", response.data);
      }
    } catch (error) {
      console.error("Error fetching student details:", error);
    } finally {
      setLoading(false);
    }
  };
  
  

  useEffect(() => {
    fetchStudentDetails();
  }, []);

  return (
    <div className="page-content-wrapper py-3">
      <div className="container" style={{ marginTop: "40px" }}>
        {/* Loader */}
        {loading && (
          <div className="text-center my-4">
            <SyncLoader
              color="orange"
              loading={loading}
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 9999,
              }}
              size={8}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        )}



        {/* Display enrollId and branchId */}
        {!loading &&
          studentDetails.map((student, index) => (
            <div key={index}>
              <div className="card user-info-card mb-3">
                <div className="card-body d-flex align-items-center mb-15">
                  <div className="user-profile me-3">
                    <img
                      src={def}
                      alt="User Profile"
                    />
                  </div>

                  <div className="user-info">
                    <h5 className="mb-1">{student.studentName}</h5>
                    <p className="mb-1">{student.className}</p>
                    {/* <p>{student.sectionName}</p> */}
                  </div>
                </div>
              </div>

              <div className="card user-data-card mb-5">
                <div className="card-body ">
                  <h5 className="mt-2">{student.branchName}</h5>
                  <hr />
                  <p>
                    <strong className="form-label">Register Number:</strong>
                    <h5>{student.register_no}</h5>
                  </p>
                  <p>
                    <strong className="form-label">Roll Number:</strong>
                    <h5>{student.roll}</h5>
                  </p>
                  <p>
                    <strong className="form-label">Mother Name:</strong>
                    <h5>{student.mother_name}</h5>
                  </p>
                  <p>
                    <strong className="form-label">Father Name:</strong>
                    <h5>{student.father_name}</h5>
                  </p>
                  <p>
                    <strong className="form-label">Class Name:</strong>
                    <h5>{student.className}</h5>
                  </p>
                  <p>
                    <strong className="form-label">Section Name:</strong>
                    <h5>{student.sectionName}</h5>
                  </p>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default StudentDetails;
